const translations = {
  'Starts in': {
    en: 'Starts in',
    es: 'Empieza en',
    pt: 'Começa em',
  },
  'programmed': {
    en: 'Programmed',
    es: 'Programado',
    pt: 'Programado',
  },
  'finished': {
    en: 'Finished',
    es: 'Finalizado',
    pt: 'Encerrado',
  },
  'This event has ended': {
    en: 'This event has ended',
    es: 'Este evento ha finalizado',
    pt: 'Este evento foi encerrado',
  },
  'This event hasn\'t started yet': {
    en: 'This event hasn\'t started yet',
    es: 'El evento aún no ha comenzado',
    pt: 'O evento ainda não começou',
  },
  'This event is scheduled for {date}': {
    en: 'This event is scheduled for {date}',
    es: 'El evento se encuentra programado para el {date}',
    pt: 'O evento está programado para {date}',
  },
  'Stay tuned for in our upcoming events section': {
    en: 'Stay tuned for in our upcoming events section',
    es: 'Mantente atento a nuestra sección de eventos futuros',
    pt: 'Fique atento à nossa seção de eventos futuros',
  },
  'You can access the full replay of this event': {
    en: 'You can access the full replay of this event',
    es: 'Puedes acceder a la repetición completa de este evento',
    pt: 'Você pode acessar a repetição completa deste evento',
  },
  'See event': {
    en: 'See event',
    es: 'Ver evento',
    pt: 'Ver evento',
  },
  'Live now': {
    en: 'Live now',
    es: 'En vivo ahora',
    pt: 'Ao vivo agora',
  },
  'Today at {time}': {
    en: 'Today at {time}',
    es: 'Hoy a las {time}',
    pt: 'Hoje às {time}',
  },
  'Tomorrow at {time}': {
    en: 'Tomorrow at {time}',
    es: 'Mañana a las {time}',
    pt: 'Amanhã às {time}',
  },
  '{weekday} at {time}': {
    en: '{weekday} at {time}',
    es: '{weekday} a las {time}',
    pt: '{weekday} às {time}',
  },
  '{date} at {time}': {
    en: '{date} at {time}',
    es: '{date} a las {time}',
    pt: '{date} às {time}',
  },
  '{time} hs': {
    en: '{time}',
    es: '{time} hs',
    pt: '{time}h',
  },
  '{distanceToNow}': {
    en: '{distanceToNow} ago',
    es: 'Hace {distanceToNow}',
    pt: 'Há {distanceToNow}',
  },
}

export default translations